<template>
  <div>
    <div>
      <v-breadcrumbs
        class="px-0"
        :items="[
          { title: '発達記録', href: '/child-development', color: 'primary' },
          { title: `${className} (${year}年度)` },
        ]"
      ></v-breadcrumbs>
    </div>
    <page-title :value="`発達記録 - ${className} (${year}年度)`" />
    <div
      class="ma-2"
    >
      <v-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                園児名
              </th>
              <th class="text-left">
                年齢
              </th>
              <th class="text-left">
                発達記録
              </th>
              <th class="text-left">
                経過記録
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(c, i) in children"
              :key="i"
            >
              <td> {{ `${c.lastName} ${c.firstName}` }} </td>
              <td> {{ getAgeBasedonBirthdate(c.dateOfBirth) }} </td>
              <td>
                <v-btn
                  color="primary"
                  variant="outlined"
                  :to="`/child-development/child/${year}/${c.childId}`"
                >
                  編集
                </v-btn>
              </td>
              <td>
                <v-btn
                  color="primary"
                  variant="outlined"
                  :to="`/child-development/progress/${year}/${c.childId}`"
                >
                  編集
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-table>
    </div>
  </div>
</template>
<script lang="ts">
import dayjs from 'dayjs';
import { defineComponent } from 'vue';
import PageTitle from '@/components/atoms/PageTitle.vue';

import { childDevelopmentClassModule } from '@/store/viewModules/child-development/childDevelopmentClassModule'
import { NurseryClassResponse } from 'chaild-api/lib';

interface DataType {
  isFetching: boolean;
  // showQuitChildren: boolean;
  // showDonwloadMessage: boolean;
  classId?: number;
  year?: number;
}

export default defineComponent({
  components: {
    PageTitle
  },
  data: (): DataType => {
    return {
      isFetching: false,
      classId: undefined,
      year: undefined,
    }
  },
  computed: {
    children() {
      return childDevelopmentClassModule.children
    },
    nurseryClass(): NurseryClassResponse | null {
      return childDevelopmentClassModule.nurseryClass
    },
    className(): string {
      if (this.nurseryClass) {
        return this.nurseryClass.className
      }
      return ''
    }
  },
  methods: {
    async listChildren() {
      if(this.classId) {
        this.isFetching = true;
        await childDevelopmentClassModule.listChildren({ classId: this.classId });
        this.isFetching = false;
      }
    },
    async getClass() {
      if(this.classId) {
        this.isFetching = true;
        await childDevelopmentClassModule.getClass({ classId: this.classId });
        this.isFetching = false;
      }
    },
    formatDate(dateString: string | null) {
      if (!dateString) {
        return '不明';
      }
      return dayjs(dateString).format('YYYY-MM-DD HH:mm')
    },
    getAgeBasedonBirthdate(birthdate: string): number {
      const thisYear = dayjs();
      return thisYear.diff(birthdate, 'year');
    },
  },
  mounted() {
    const classId = this.$route.params.classId;
    if (classId) {
      this.classId = parseInt(classId as string, 10);
      this.listChildren();
      this.getClass();
    }

    const year = this.$route.params.businessYear;
    if (year) {
      this.year = parseInt(year as string, 10);
    }
  }
})
</script>